import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { connect, useDispatch } from 'react-redux'
import { Row, Col } from 'antd'
import RootState from 'typings/RootState'
import { DropdownList } from 'Components/Shared/Form'
import { CloseIcon } from 'Components/Shared/Icon'
import PrimaryButton from 'Components/Shared/Button/PrimaryButton'
import { InputText } from 'Components/Shared/Input'
import { DataItem } from 'features/admin/qcType/types'

type Props = ReduxProps &
  DispatchProps & {
    item: any
    onSave?: (item: any) => void
    onClose: () => void
    isUpdateMode?: boolean
  }

const SettingConfigDetail: React.ComponentType<Props> = props => {
  const { item, isUpdateMode = false } = props
  const [dataItem, setdataItem] = useState({} as any)

  const dispatch = useDispatch()

  useEffect(() => {
    setdataItem(item)
  }, [item])

  const status = [
    {
      name: 'Active',
      value: 'A',
    },
    {
      name: 'InActive',
      value: 'N',
    },
  ]

  const onSave = () => {
    if (props.onSave) {
      props.onSave(dataItem)
    }
  }

  return (
    <MainPage>
      <Header>
        <CloseIcon color="#8b99a7" size={24} onClick={props.onClose} />
      </Header>
      <Row>
        <Col span={24}>
          <Title>ตั้งค่า Config</Title>
        </Col>
        <Col span={24}>
          <BodyArea>
            <InputText
              prefix="Parameter"
              value={dataItem.Parameter}
              onChange={(val: string) => {
                dataItem.Parameter = val
                setdataItem({ ...dataItem })
              }}
              placeholder="ระบุ Parameter"
            />
          </BodyArea>
        </Col>

        <Col span={24}>
          <BodyArea>
            <InputText
              prefix="Value"
              value={dataItem.Value}
              onChange={(val: string) => {
                dataItem.Value = val
                setdataItem({ ...dataItem })
              }}
              placeholder="ระบุ Value"
            />
          </BodyArea>
        </Col>

        {isUpdateMode == true && (
          <Col span={24}>
            <BodyArea>
              <DropdownList
                label="สถานะ"
                value={dataItem.Active}
                menu={status}
                onChange={(val: string) => {
                  dataItem.Active = val
                  setdataItem({ ...dataItem })
                }}
              />
            </BodyArea>
          </Col>
        )}

        <Col span={24}>
          <BodyArea>
            <InputText
              prefix="Description"
              value={dataItem.Description}
              onChange={(val: string) => {
                dataItem.Description = val
                setdataItem({ ...dataItem })
              }}
              placeholder="ระบุ Description"
            />
          </BodyArea>
        </Col>

        <Col span={24}>
          <BodyArea>
            <InputText
              prefix="Remark"
              value={dataItem.Remark}
              onChange={(val: string) => {
                dataItem.Remark = val
                setdataItem({ ...dataItem })
              }}
              placeholder="ระบุ Remark"
            />
          </BodyArea>
        </Col>
      </Row>
      <Row type="flex" justify="end">
        <SaveArea>
          <PrimaryButton onClick={onSave} text="บันทึก" />
        </SaveArea>
      </Row>
    </MainPage>
  )
}

const MainPage = styled.div`
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  overflow-x: scroll;
`

const Header = styled.div`
  text-align: right;
  height: 40px;

  svg {
    cursor: pointer;
  }
`

const Title = styled.div`
  color: black;
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 28px;
  margin-bottom: 14px;
`

const Text = styled.div`
  color: black;
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 20px;
`

const SaveArea = styled.div`
  margin-top: 32px;
  float: right;
  width: 160px;
`

const BodyArea = styled.div`
  font-family: 'DB Helvethaica X 55 Regular';
  span {
    font-size: 20px;
  }
  .ant-dropdown-trigger {
    margin-bottom: 12px;
  }
  .input-title {
    margin-bottom: 12px;
  }
`

const mapStateToProps = (state: RootState) => {
  return {}
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(SettingConfigDetail)
